import React, { useState } from 'react';
import { Container, Table, Form, Button } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { _bookappointmentsbydoctor } from '../../constants/api';
import { CircularProgress } from '@mui/material';

const TotalTreatments = () => {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [loading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);

    async function fetchTotalTreatments(body) {
        setIsLoading(true)
        try {
            const userData = JSON.parse(localStorage.getItem('user'));
            const token = userData?.token;

            if (!token) {
                throw new Error('Token not found');
            }

            const response = await fetch(`${_bookappointmentsbydoctor}?startDate=${startDate}&endDate=${endDate}`, {
                method: "GET",
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'clientid': 'e0ce9cb8-430e-4148-b562-b8833cc9fa0b',
                }
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch total treatments: ${response.statusText}`);
            }

            const res = await response.json();
            setData(res)
        } catch (error) {
            console.log('Error in fetch total treatmentss API ==> ', error);
            throw error;
        }
        setIsLoading(false)
    };

    const handleSubmit = async () => {
        const payload = {
            startDate: startDate ? startDate.toISOString().split('T')[0] : "",
            endDate: endDate ? endDate.toISOString().split('T')[0] : ""
        };
        await fetchTotalTreatments(payload)
    };

    return (
        <Container className="mt-4">
            <h2 className="mb-3">Total Appointments</h2>
            <Form className="mb-3">
                <div className='d-flex gap-2'>
                    <Form.Group className="">
                        <Form.Label>Start Date</Form.Label>
                        <DatePicker selected={startDate} onChange={date => setStartDate(date)} className="form-control" />
                    </Form.Group>
                    <Form.Group className="">
                        <Form.Label>End Date</Form.Label>
                        <DatePicker selected={endDate} onChange={date => setEndDate(date)} className="form-control" />
                    </Form.Group>
                </div>
                <Button onClick={handleSubmit} variant="primary">Submit</Button>
            </Form>
            {loading ? <CircularProgress /> : <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Yuva ID</th>
                        <th>Email</th>
                        <th>Appointment Count</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.name}</td>
                            <td>{item.yuvaid}</td>
                            <td>{item.email}</td>
                            <td>{item.appointments.count || 0}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>}
        </Container>
    );
};

export default TotalTreatments;
